import { useTranslation } from 'react-i18next'
import { Box, FormControlLabel, Switch, Typography } from '@mui/material'

type Props = {
  handleOnChange: any
  state: any
}

const Enable = ({ handleOnChange, state }: Props) => {
  const { t } = useTranslation()

  return (
    <Box>
      <>
        <Typography sx={{ marginBottom: '4px' }}>
          {t('bonusStepStatus')}
        </Typography>
        <Typography fontWeight={700} sx={{ my: '20px' }}>
          {t('statusBonus')}
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={state.isActive.value}
              onChange={(event: any, newValue: any | null) => {
                handleOnChange('isActive', newValue)
              }}
              name="isActive"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
          }
          label={
            state.isActive.value ? t('status.enabled') : t('status.disabled')
          }
        />
      </>
      {/* {process.env.REACT_APP_STAGE !== 'prod' && (
        <>
          <Typography fontWeight={700} sx={{ my: '20px' }}>
            {t('isMakeUpRule')}
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={state.isMakeUpRule.value}
                onChange={(event: any, newValue: any | null) => {
                  handleOnChange('isMakeUpRule', newValue)
                }}
                name="isMakeUpRule"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
                color="primary"
              />
            }
            label={
              state.isMakeUpRule.value
                ? t('status.enabled')
                : t('status.disabled')
            }
          />
        </>
      )} */}
    </Box>
  )
}

export default Enable
